module.exports = __webpack_public_path__ + "static/media/Yellow_Side.dcb4a96d.jpg";